import React from 'react';
import { CreateCaseForm, GenericCard } from '@/components/dashboard';
import { CaseDetailsLayout, CasePhaseHeader } from '../cases';
import { CaseContext } from '@/context/CaseContext';

export const CreateCaseScreen: React.FC = () => {
	const { caseDetails } = React.useContext(CaseContext);

	return (
		<CaseDetailsLayout numberPhase={1} namePhase="Investigation">
			<GenericCard className="border !h-fit">
				<CasePhaseHeader title="Case Details" status="default" position="1" />
				<div className="pl-[50px]">
					<CreateCaseForm caseDetails={caseDetails} />
				</div>
			</GenericCard>
		</CaseDetailsLayout>
	);
};
